import {
  cycleCountIdFormat,
  cycleCountLineIdFormat,
  cycleCountRuleIdFormat,
  locationIdFormat,
  productIdFormat,
  storageLocationIdFormat,
  taskIdFormat,
} from "@redotech/redo-ids-cockroach";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import {
  cycleCountSourceSchema,
  cycleCountStatusSchema,
} from "./list-cycle-counts";

const lineItem = z.object({
  lineId: cycleCountLineIdFormat.schema,
  productId: productIdFormat.schema,
  title: z.string(),
  sku: z.string().nullable(),
  storageLocationId: storageLocationIdFormat.schema,
  storageLocationName: z.string().nullable(),
  expectedCount: z.int(),
  finalCount: z.int().nullable(),
});

export const getCycleCount = unaryRpc({
  name: "getCycleCount" as const,
  input: z.object({ id: cycleCountIdFormat.schema }),
  output: z.object({
    id: cycleCountIdFormat.schema,
    taskId: taskIdFormat.schema.nullable(),
    name: z.string().nullable(),
    status: cycleCountStatusSchema,
    source: cycleCountSourceSchema,
    locationId: locationIdFormat.schema,
    locationName: z.string(),
    cycleCountRuleId: cycleCountRuleIdFormat.schema.nullable(),
    ruleName: z.string().nullable(),
    assignedRole: z.string().nullable(),
    assignedUserId: z.string().nullable(),
    dueAt: z.date().nullable(),
    createdAt: z.date(),
    lines: z.array(lineItem),
  }),
});
